import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var Mouse = /** @class */ (function (_super) {
    __extends(Mouse, _super);
    function Mouse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Mouse, "cursor", {
        /*
         The name of the native cursor.
         */
        get: function () {
            return Mouse._cursor;
        },
        set: function (value) {
            Mouse._cursor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Mouse, "supportsCursor", {
        /*
         [read-only] Indicates whether the computer or device displays a persistent cursor.
         */
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/Mouse', 'static get supportsCursor', '');
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Mouse, "supportsNativeCursor", {
        /*
         [read-only] Indicates whether the current configuration supports native cursors.
         */
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/Mouse', 'static get supportsNativeCursor', '');
            return true;
        },
        enumerable: true,
        configurable: true
    });
    /*
     Hides the pointer.
     */
    Mouse.hide = function () {
        this.sec.player.mouseManager.showCursor = false;
        // @todo
        // Debug.throwPIR('playerglobals/ui/Mouse', 'static hide', '');
    };
    /*
     Displays the pointer.
     */
    Mouse.show = function () {
        this.sec.player.mouseManager.showCursor = true;
        // @todo
        // Debug.throwPIR('playerglobals/ui/Mouse', 'static show', '');
    };
    /*
     Registers a native cursor under the given name, with the given data.
     */
    Mouse.registerCursor = function (name, cursor) {
        // @todo
        Debug.throwPIR('playerglobals/ui/Mouse', 'static registerCursor', '');
    };
    /*
     Unregisters a native cursor under the given name, with the given data.
     */
    Mouse.unregisterCursor = function (name) {
        // @todo
        Debug.throwPIR('playerglobals/ui/Mouse', 'static unregisterCursor', '');
    };
    return Mouse;
}(ASObject));
export { Mouse };
